import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import ServiceTypeEditDialog from './ServiceTypeEditDialog/ServiceTypeEditDialog';

function ServiceTypesDataTable() {

  // #region Vars and Consts

  const [serviceTypes, setServiceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editDialogIsVisible, setEditDialogIsVisible] = useState(false);
  const [selectedServiceType, setSelectedServiceType] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const activeTypes = [{ label: 'Activo', value: true }, { label: 'Inactivo', value: false }]
  const [filters, setFilters] = useState({
    'global': {
      value: null,
      matchMode: FilterMatchMode.CONTAINS
    },
    "description": {
      operator: FilterOperator.AND,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.CONTAINS
      }]
    },
    "active": {
      operator: FilterOperator.OR,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.EQUALS
      }]
    }
  });

  // #endregion

  // #region Methods

  const getServiceTypes = () => {
    console.group("Get service types");
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/serviceType/findAll`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          console.log("Service types", data.responseObject);
          setServiceTypes(data.responseObject);
        } else {
          console.warn('Error getting service types', data);
        }
        setLoading(false);
        console.groupEnd();
      }, (error) => {
        console.error("Error getting service types", error);
        console.groupEnd();
      });
  };

  // #endregion 

  // #region Events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    const _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  }

  const onNewClick = () => {
    setSelectedServiceType(null);
    setEditDialogIsVisible(true);
  };

  const onServiceTypeSaved = () => {
    setEditDialogIsVisible(false);
    getServiceTypes();
  };

  const onEditClick = (serviceType) => {
    setSelectedServiceType(serviceType);
    setEditDialogIsVisible(true);
  };

  useEffect(() => {
    getServiceTypes();
  }, []);

  // #endregion

  // #region Templates

  const headerTemplate = (
    <>
      <Row>
        <Col md={8}>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              placeholder="Filtrar"
              value={globalFilter}
              onChange={onGlobalFilterChange} />
          </span>
        </Col>
        <Col md={4}>
          <Button
            label="Nuevo"
            className="p-button-raised p-button-sm float-end"
            onClick={onNewClick}
          />
        </Col>
      </Row>
    </>
  );

  const dataTableActionsTemplate = (serviceType) => {
    return (
      <>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-primary p-button-text mr-2"
          onClick={() => onEditClick(serviceType)} />
      </>
    );
  };

  const activeFieldTemplate = (serviceType) => {
    return (
      serviceType.active ? <i className="pi pi-check text-primary"></i> : <></>
    );
  }

  const activeTypeFilterTemplate = (option) => {
    return <span>{option.label}</span>;
  };

  const activeTypesFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={activeTypes}
        onChange={(e) => options.filterCallback(e.value)}
        itemTemplate={activeTypeFilterTemplate}
        placeholder="Selecciona el estatus activo"
        showClear />
    );
  };

  const dataTableTemplate = (
    <>
      <div className="card">
        <DataTable
          className=""
          showGridlines
          stripedRows
          size="small"
          responsiveLayout="scroll"
          emptyMessage="No se encontraron tipos de servicio"
          value={serviceTypes}
          header={headerTemplate}
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          resizableColumns
          columnResizeMode="fit"
          globalFilterFields={[         
            "description",            
            "active"
          ]}>
          <Column
            className='app-w-50-px text-center'
            body={dataTableActionsTemplate}
            exportable={false} />
          <Column
            field="description"
            header="Descripción"
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por Descripción"
            sortable />          
          <Column
            field="active"
            header="Activo"
            className='app-w-200-px text-center'
            filter
            filterPlaceholder="Buscar por Activo"
            filterElement={activeTypesFilterTemplate}
            body={activeFieldTemplate}
            sortable />
        </DataTable>
      </div>
    </>
  );

  // #endregion

  return (
    <>
      <article>
        {dataTableTemplate}
        <ServiceTypeEditDialog
          visible={editDialogIsVisible}
          onHide={() => setEditDialogIsVisible(false)}
          onServiceTypeSaved={onServiceTypeSaved}
          serviceType={selectedServiceType}
        />
      </article>
    </>
  );
}

export default ServiceTypesDataTable;